module.exports = __webpack_public_path__ + "img/40_00_078_575.fe4716e5.jpg";